import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  Card,
  CardBody,
  Progress,
  Button,
  Row,
  Col,
  Modal,
  ModalBody,
} from 'reactstrap';
import { useUserAuth } from "../../context/UserContext.js";
import { FaArrowLeft, FaArrowRight, FaRedo, FaCheck } from 'react-icons/fa';
import { useTranslation } from "react-i18next";
import { requestQuizFromAI } from "../../services/RobotAIServices.js";

import { setUserQuizContent, setQuizResult } from "../../services/userService.js";
import "./QuizComponent.css";

// "A", "B", "C"... for option index 0, 1, 2...
const optionLetter = (index) => String.fromCharCode(65 + index);


const QuizComponent = ({ lessonID, completedLessonList, setQuizCompletedFlag, questionsCount }) => {



  const { user } = useUserAuth();
  const { t } = useTranslation();

  const [current, setCurrent] = useState(0);
  const [score, setScore] = useState(0);

  const [showModal, setShowModal] = useState(false);


  const [quizQuestions, setQuizQuestions] = useState([]);

  //   const [completedLessonList, setCompletedLessonList] = useState([
  //     "What Is JavaScript?",
  //     "Where Does JavaScript Run?",
  //     "How to Write and Run JavaScript",
  //     "Comments in JavaScript",
  //     "Basic Syntax of JavaScript",
  //     "Indentation",
  //     "Naming Conventions",
  //     "Semicolons",
  //   ]);

  const [userAnswers, setUserAnswers] = useState(Array(questionsCount).fill(null));
  // This question's answer, so going back shows (and announces) the choice
  // made there, and a new question opens with nothing chosen.
  const selected = userAnswers[current] ?? null;

  const PASS_PERCENT = 80;
  const passNeeded = Math.ceil((PASS_PERCENT / 100) * questionsCount); // 80% of 10 = 8
  const passed = score >= passNeeded;
  const percent = Math.round((score / questionsCount) * 100);

  const [submittedAnswers, setSubmittedAnswers] = useState(
    Array(questionsCount).fill(false)
  );
  const isSubmitted = submittedAnswers[current] === true;

  // Next and Previous swap the question and can disable the button that was
  // pressed, so focus moves to the new question, which is then read out.
  const questionRef = useRef(null);
  const shownQuestion = useRef(current);
  useEffect(() => {
    if (shownQuestion.current === current) return;
    shownQuestion.current = current;
    questionRef.current?.focus();
  }, [current]);


  useEffect(() => {
    requestQuizQuestions();
  }, []);


  const requestQuizQuestions = async () => {
    setQuizQuestions([]); // optional: show Loading quiz... again

    let currentUser = user;

    const res2 = await requestQuizFromAI(completedLessonList);

    if (res2.function_call?.name === "returnQuizQuestions") {
      const args = JSON.parse(res2.function_call.arguments);
      const quizData = args.quizQuestions;
      setQuizQuestions(quizData);
      await setUserQuizContent(currentUser, lessonID, quizData)
    }

  }


  const selectOption = (index) => {
    if (submittedAnswers[current]) return; // locked if already submitted

    const newAnswers = [...userAnswers];
    newAnswers[current] = index;
    setUserAnswers(newAnswers);
  };

  const nextQuestion = () => {
    // if (selected === null) {
    //   alert('Please select an answer before proceeding.');
    //   return;
    // }

    if (!isSubmitted) {
      alert(t("quiz.submitFirst"));
      return;
    }

    if (current < quizQuestions.length - 1) {
      setCurrent(current + 1);
    }
  };



  const submitQuiz = () => {
    
    if(score >= 8){
      setQuizCompletedFlag(true);
    }
    setQuizResult(user, lessonID, score)
    setShowModal(true);

  }

  const prevQuestion = () => {
    if (current > 0) setCurrent(current - 1);
  };

  const restartQuiz = async () => {
    setCurrent(0);
    setScore(0);
    setUserAnswers(Array(questionsCount).fill(null));
    setSubmittedAnswers(Array(questionsCount).fill(false));
    setShowModal(false);

    await requestQuizQuestions();
  };

  const submitCurrentAnswer = () => {
    if (selected === null) {
      alert(t("quiz.selectFirst"));
      return;
    }

    // prevent resubmit
    if (submittedAnswers[current]) return;

    const correctIndex = quizQuestions[current].answer;

    // score once
    setScore((prev) => prev + (selected === correctIndex ? 1 : 0));

    // mark this question as submitted
    setSubmittedAnswers((prev) => {
      const copy = [...prev];
      copy[current] = true;
      return copy;
    });
  };



  if (!quizQuestions.length) {
    return (
      <div className='splitpane-wrapper'>
        <Container className="pr-0 pl-0 d-flex justify-content-center">
          <Card className="w-100" style={{ maxWidth: '800px' }}>
            <CardBody className="text-center">
              {t("quiz.loading")}
            </CardBody>
          </Card>
        </Container>
      </div>
    );
  }

  return (

    <div className='  splitpane-wrapper  '>
      <Container className="pr-0 pl-0    d-flex justify-content-center  ">
        <Card className="w-100" style={{ maxWidth: '800px' }}>
          <div className="bg-light">
            <Progress value={((current + 1) / quizQuestions.length) * 100} />
          </div>
          <CardBody>
            <Row className="mb-3">
              <Col className="text-muted">
                {t("hotspot.stepOf", { step: current + 1, total: quizQuestions.length })}
              </Col>
              <Col className="text-muted text-end">{t("quiz.score", { score })}</Col>
            </Row>

            {/* <div className="mb-4">
              {quizQuestions[current].options.map((opt, index) => (
                <div
                  key={index}
                  className={`border rounded p-3 mb-2 cursor-pointer ${selected === index ? 'bg-primary text-white border-primary' : 'bg-white'} option`}
                  style={{ transition: '0.3s', cursor: 'pointer' }}
                  onClick={() => selectOption(index)}
                >
                  <strong>{String.fromCharCode(65 + index)}.</strong> {opt}
                </div>
              ))}
            </div> */}


            {/* A radio group: the question is the legend, and each option is
                a visually hidden radio whose label is the card you see. */}
            <fieldset className="mb-4">
              <legend className="mb-4">
                <h4 className="mb-0" ref={questionRef} tabIndex={-1}>{quizQuestions[current].question}</h4>
              </legend>
              {quizQuestions[current].options.map((opt, index) => {
                const correctIndex = quizQuestions[current].answer;
                const isSelected = selected === index;
                const isCorrect = index === correctIndex;
                const optionId = `quiz-q${current}-option${index}`;

                // Decide classes after feedback is shown
                let optionClass = "bg-white";
                if (isSubmitted) {
                  if (isCorrect) optionClass = "bg-success text-white border-success";
                  else if (isSelected && !isCorrect) optionClass = "bg-danger text-white border-danger";
                } else {
                  if (isSelected) optionClass = "bg-primary text-white border-primary";
                }

                return (
                  <React.Fragment key={index}>
                    <input
                      type="radio"
                      className="sr-only quiz-option-input"
                      id={optionId}
                      name={`quiz-q${current}`}
                      checked={isSelected}
                      disabled={isSubmitted}
                      onChange={() => selectOption(index)}
                    />
                    <label
                      htmlFor={optionId}
                      className={`d-block border rounded p-3 mb-2 option quiz-option ${optionClass}`}
                      style={{
                        transition: "0.3s",
                        cursor: isSubmitted ? "default" : "pointer",
                        opacity: isSubmitted && !isCorrect && !isSelected ? 0.85 : 1,
                      }}
                    >
                      <span className="d-flex justify-content-between align-items-start">
                        <span>
                          <strong>{optionLetter(index)}.</strong> {opt}
                        </span>


                        {isSubmitted && isCorrect && (
                          <span className="badge bg-light text-dark ms-3">{t("quiz.correctBadge")}</span>
                        )}
                        {isSubmitted && isSelected && !isCorrect && (
                          <span className="badge bg-light text-dark ms-3">{t("quiz.yourAnswer")}</span>
                        )}
                      </span>
                    </label>
                  </React.Fragment>
                );
              })}
            </fieldset>

            {/* Says whether the submitted answer was right; the colours and
                badges above show it, this tells screen readers. */}
            <p className="sr-only" role="status" aria-live="polite" aria-atomic="true">
              {isSubmitted &&
                (selected === quizQuestions[current].answer
                  ? t("quiz.correctFeedback")
                  : t("quiz.incorrectFeedback", {
                      answer: optionLetter(quizQuestions[current].answer),
                    }))}
            </p>
            <div className="d-flex justify-content-between">
              <Button
                onClick={prevQuestion}
                color="secondary"
                disabled={current === 0}
              >
                <FaArrowLeft className="me-2" /> {t("quiz.previous")}
              </Button>

              {/* RIGHT SIDE BUTTONS */}
              {current === quizQuestions.length - 1 ? (
                // LAST QUESTION FLOW
                !isSubmitted ? (
                  <Button
                    color="primary"
                    onClick={submitCurrentAnswer}
                    disabled={selected === null}
                  >
                    <span>{t("regular.submit")}</span> <FaCheck className="ms-2" />
                  </Button>
                ) : (
                  <Button color="primary" onClick={submitQuiz}>
                    <span>{t("quiz.finish")}</span> <FaCheck className="ms-2" />
                  </Button>
                )
              ) : (
                // NORMAL QUESTION FLOW
                !isSubmitted ? (
                  <Button
                    color="primary"
                    onClick={submitCurrentAnswer}
                    disabled={selected === null}
                  >
                    <span>{t("regular.submit")}</span> <FaCheck className="ms-2" />
                  </Button>
                ) : (
                  <Button color="primary" onClick={nextQuestion}>
                    <span>{t("regular.next")}</span> <FaArrowRight className="ms-2" />
                  </Button>
                )
              )}
            </div>


            {/* <div className="d-flex justify-content-between">
              <Button
                onClick={prevQuestion}
                color="secondary"
                disabled={current === 0}
              >
                <FaArrowLeft className="me-2" /> Previous
              </Button>

              {current === quizQuestions.length - 1 ? (
                <Button color="primary" onClick={submitQuiz}>
                  <><span>Submit</span> <FaCheck className="ms-2" /></>
                </Button>
              ) : (
                <Button color="primary" onClick={nextQuestion}>
                  <><span>Next</span> <FaArrowRight className="ms-2" /></>
                </Button>
              )}

            </div> */}
          </CardBody>
        </Card>

        {/* Results Modal */}
        <Modal isOpen={showModal} centered labelledBy="quiz-result-title">
          <ModalBody className="text-center p-5">
            <div className="display-3 mb-3" aria-hidden="true">🎉</div>
            <h4 className="mb-3" id="quiz-result-title">{t("quiz.completedTitle")}</h4>
            <p className="mb-4">
              {t("quiz.scoredBefore")} <strong className="text-primary">{score}</strong>{" "}
              {t("quiz.scoredAfter", { total: questionsCount })}
            </p>

            <p className="mb-4">
              {passed ? (
                <span className="text-success">{t("quiz.passed")}</span>
              ) : (
                <span className="text-danger">{t("quiz.needToPass")}</span>
              )}
            </p>

            <div className="d-grid gap-2">
              {!passed ? (
                <Button color="primary" onClick={restartQuiz}>
                  <FaRedo className="me-2" /> {t("quiz.retake")}
                </Button>

              ) : (
                <Button color="secondary" onClick={() => setShowModal(false)}>
                  {t("deleteAccount.close")}
                </Button>
              )}
            </div>
          </ModalBody>
        </Modal>
      </Container>
    </div>

  );
}



export default QuizComponent;